"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTabObjects = void 0;
const react_1 = __importDefault(require("react"));
const lowerCase_1 = __importDefault(require("lodash/lowerCase"));
const useTabObjects = (tabs) => {
    const tabObjects = react_1.default.useMemo(() => tabs.map((tab) => {
        if (typeof tab === 'string') {
            return {
                id: tab,
                label: tab,
                targetId: `section-${(0, lowerCase_1.default)(tab)}`
            };
        }
        return tab;
    }), [tabs]);
    return tabObjects;
};
exports.useTabObjects = useTabObjects;
//# sourceMappingURL=useTabObjects.js.map